import { render, staticRenderFns } from "./AssetImageInspector.vue?vue&type=template&id=6d2e1d2d&scoped=true&"
import script from "./AssetImageInspector.vue?vue&type=script&lang=js&"
export * from "./AssetImageInspector.vue?vue&type=script&lang=js&"
import style0 from "./AssetImageInspector.vue?vue&type=style&index=0&id=6d2e1d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e1d2d",
  null
  
)

export default component.exports